import React from 'react';
import MessageDetailSection from '../../../sections/AdminDashboard/Messaging/MessageDetail';

const MessageDetail = () => {
  return <MessageDetailSection />;
};

export default MessageDetail;

